import { Component, ChangeDetectionStrategy } from '@angular/core';
import { InputComponent } from '../input/input.component';

@Component({
    selector: 'app-checkbox',
    templateUrl: './checkbox.component.html',
    styleUrls: ['./checkbox.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CheckboxComponent extends InputComponent {
}
